export default "__VITE_ASSET__CWXVhYmr__"